import React from 'react';
import { Switch } from 'react-router-dom';
import { FourOhFourErrorPage } from '@sm/webassets';
import Layout from '~pricing/components/Layout';
import pages from '~pricing/pages';

import PricingRoutes from './PricingRoutes';

const ROUTES = pages.map(page => {
  return page.paths.map((path: string) => {
    return <PricingRoutes key={path} path={path} exact redirectPath="/pricing" component={page.component} />;
  });
});

const PricingRouter = (): JSX.Element => {
  return (
    <Layout>
      <Switch>
        {ROUTES}
        <FourOhFourErrorPage />
      </Switch>
    </Layout>
  );
};

export default PricingRouter;
